import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-565c022b"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "switch-icon"
}, null, -1));
const _hoisted_2 = {
  class: "switch-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`game-switch ${$data.value ? 'on' : 'off'}`),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.updateValue && $options.updateValue(...args))
  }, [_hoisted_1, _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`common.${$data.value ? 'on' : 'off'}`).toUpperCase()), 1)], 2);
}